import * as Sentry from '@sentry/vue'
import OpenAIUtils from '@/utils/open-ai/OpenAIUtils'
import openAIAPI from '@/api/openai'
import Utils from '@/util'
import i18nPresenter from '@/i18nPresenter'

const state = {
  autoCompleteSlideOption: [],
  loadingAutocomplete: false,
  autocompleteError: null,
}

const getters = {
  autoCompleteSlideOption: (state) => state.autoCompleteSlideOption,
  isApprovalAllowed: (state) => state.autoCompleteSlideOption.length > 0,
  isLoadingAutocomplete: (state) => state.loadingAutocomplete,
  autocompleteError: (state) => state.autocompleteError,
}
const services = {
  async generateSlideOptions(payload) {
    try {
      const response = await openAIAPI.generateSlideOptions(payload)
      return response.slideOptions
    } catch (error) {
      throw new Error(i18nPresenter.t('Error fetching answers from API'))
    }
  },
  handleSlideOptionsError(commit, errorMessage) {
    commit('setAutocompleteError', i18nPresenter.t(errorMessage))
    commit('setLoadingAutocomplete', false)
  },

  clearSlideOptionsState(commit) {
    commit('setLoadingAutocomplete', false)
    commit('setAutocompleteError', null)
  },

}

const mutations = {

  setLoadingAutocomplete(state, isLoading) {
    state.loadingAutocomplete = isLoading
  },
  setAutocompleteError(state, error) {
    state.autocompleteError = error
  },
}

const actions = {
  async generateSlideOptionsAction({ commit, rootState }, questionContent) {
    const MAX_ANSWERS = 8

    try {
      const { SlideOptions: activeSlideOptions, id: slideId } = rootState.slideActive

      // Validate question content
      if (!OpenAIUtils.shouldGenerateSlideOptions(questionContent)) {
        return
      }

      commit('setLoadingAutocomplete', true)

      // Fetch slide options
      let fetchedSlideOptions
      try {
        fetchedSlideOptions = await services.generateSlideOptions({ slideId })
      } catch (apiError) {
        services.handleSlideOptionsError(commit, 'Error fetching slide options from API')
        return
      }

      // Check max allowed options
      if (activeSlideOptions.length >= MAX_ANSWERS) {
        services.handleSlideOptionsError(
          commit,
          'There are already too many options. Please remove some to make room for new ones.',
        )
        return
      }

      // Update slide options and notify success
      const newOptionsCount = fetchedSlideOptions.length - activeSlideOptions.length
      Utils.showToastSuccess(`${newOptionsCount} options have been generated.`)
      commit('updateSlideActive', { SlideOptions: fetchedSlideOptions }, { root: true })

      services.clearSlideOptionsState(commit)
    } catch (error) {
      Sentry.captureException(error)
    } finally {
      services.clearSlideOptionsState(commit)
    }
  },
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
